import React, {MutableRefObject, useEffect} from 'react';
import {isOntMessageOriginAllowed} from "../../helpers";

interface StepUpFormProps {
    formRef: MutableRefObject<HTMLFormElement>;
    formAction: string;
    jwt: string;
    md?: string|null;
    onCompleted: Function;
    onError: Function;
}

export default function StepUpForm({
    formRef,
    formAction,
    jwt,
    md = '',
    onCompleted,
    onError
}: StepUpFormProps)  {
    useEffect(() => {
        const handleMessage = function (event: MessageEvent<any>): void {
            if (!isOntMessageOriginAllowed(event.origin)) {
                return;
            }
            if (event.data === 'ont3ds_return_transaction_processed') {
                onCompleted();
            }
            if (event.data === 'ont3ds_return_transaction_failed') {
                onError();
            }
        }
        window.addEventListener("message", (event) => handleMessage(event));

        return () => {window.removeEventListener("message", handleMessage)};
    }, []);

    return (
        <form target="3ds_step_up_iframe" ref={formRef} method="post" action={formAction}>
            <input type="hidden" name="JWT" value={jwt}/>
            <input id="md-data" type="hidden" name="MD" value={md}/>
        </form>
    );
}
